// store/slices/OrgUnitSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface OrgUnitState {
  id: string | null;
  name: string | null;
}

const initialState: OrgUnitState = {
  id: null,
  name: null,
};

const OrgUnitSlice = createSlice({
  name: 'orgUnit',
  initialState,
  reducers: {
    setOrgUnit: (state, action: PayloadAction<{ id: string; name: string }>) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
    },
    resetOrgUnit: (state) => {
      state.id = null;
      state.name = null;
    },
  },
});

export const { setOrgUnit, resetOrgUnit } = OrgUnitSlice.actions;
export default OrgUnitSlice.reducer;
